export const WIDGET_TYPE = {
  COLLECTIONS: "COLLECTIONS",
  PRODUCT_COLLECTION: "PRODUCT_COLLECTION",
  PRODUCTS_WITH_TABS: "PRODUCTS_WITH_TABS",
  VIDEO: "VIDEO",
};

export const LAYOUT_TYPE = {
  GRID: "grid",
  CAROUSEL: "carousel",
};

export const MEDIA_TYPE = {
  IMAGE: "image",
  VIDEO: "video",
  LOTTIE: "lottie",
  RIVE: "rive",
  COLOR: "color",
  GRADIENT: "gradient",
};

// ...existing code...

export const TAB_ALIGNMENT = {
  LEFT: "left",
  RIGHT: "right",
  START: "start",
  CENTER: "center",
  END: "end",
};

export const TAB_ALIGNMENT_CLASS = {
  [TAB_ALIGNMENT.START]: "mr-auto",
  [TAB_ALIGNMENT.CENTER]: "mx-auto",
  [TAB_ALIGNMENT.END]: "ml-auto",
};

export const ALIGNMENT_NORMALIZER = {
  [TAB_ALIGNMENT.LEFT]: TAB_ALIGNMENT.START,
  [TAB_ALIGNMENT.START]: TAB_ALIGNMENT.START,
  [TAB_ALIGNMENT.RIGHT]: TAB_ALIGNMENT.END,
  [TAB_ALIGNMENT.END]: TAB_ALIGNMENT.END,
};
